<template>
  <v-layout row justify-center>
    <v-dialog v-model="isVisible" scrollable persistent max-width="600px">
      <v-form v-model="valid">
        <v-card>
          <v-card-title>
            <span class="headline">{{title}}</span>
            <v-spacer></v-spacer>
            <small>*indicates required field</small>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px">
            <v-container grid-list-sm fluid>
              <v-layout row wrap>
                <v-flex v-for="(component, index) in fields" v-if="showInput(component)"
                  :key="`${title}-${index}`" xs12 md6>
                  <v-layout align-center>
                    <v-flex>
                      <v-text-field v-model="fieldModel[component.param]"
                        :readonly="isEdit && component.identifier" v-show="!component.hidden"
                        :label="component.name" :required="component.required" outline prepend="*" :rules="rule(component)">
                        <template v-if="component.required" v-slot:append>
                          *
                        </template>
                        <template v-if="component.required" v-slot:append>
                          *
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-tooltip bottom v-if="component.description">
                        <template v-slot:activator="{ on }">
                          <v-icon dark v-on="on">info</v-icon>
                        </template>
                        <span>
                          <vue-markdown>{{component.description}}</vue-markdown>
                        </span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat @click="close">Close</v-btn>
            <v-btn color="success" :disabled="!valid" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import VueMarkdown from 'vue-markdown'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    fields: Array,
    title: String,
    data: Object,
    action: String,
  },
  components: {
    VueMarkdown,
  },
  data() {
    return {
      valid: false,
      fieldModel: {},
      description: {},
      isVisible: false,
      initialState: null
    }
  },
  mounted() {
    if (this.isEdit) { this.initialState = Object.assign({}, this.init(true)) }
    this.fieldModel = Object.assign({}, this.init())
    this.isVisible = this.show
  },
  methods: {
    init(ignoreId = false) {
      function defaultValue(type) {
        switch (type) {
          case 'number':
            return 0
          case 'boolean':
            return false
          case 'text':
          default:
            return ''
        }
      }

      function extractData(component) {
        if (this.data && this.data[component.param]) {
          if (component.type === 'json') { return JSON.stringify(this.data[component.param]) }
          return this.data[component.param]
        } else {
          return defaultValue(component.type)
        }
      }

      let abc = extractData.bind(this)
      const obj = {}
      this.fields.forEach(component => {
        if (!component.identifier || !ignoreId) {
          if (!(this.action === 'new' && component.autoIncrement)) {
            obj[component.param] = abc(component)
          }
        }
      })
      return obj
    },
    // Input validation rules
    rule(options) {
      const ruleList = []
      if (options.required) {
        ruleList.push(v => !!v || options.name + ' is required')
      }
      switch (options.type) {
        case 'number':
          ruleList.push(v => !isNaN(v) || 'Please enter a vlaid number')
          break
      }
      return ruleList
    },
    showInput(component) {
      if (this.action === 'new') {
        return !(component.autoIncrement || component.hidden)
      }
      return !component.hidden
    },
    save() {
      this.isVisible = false
      const payload = {}
      // payload.component = this.activeComponent.component
      if (this.isEdit) {
        const updatedValues = {}
        Object.keys(this.fieldModel).forEach(param => {
          if (this.initialState[param] === undefined || this.initialState[param] !== this.fieldModel[param]) { updatedValues[param] = this.fieldModel[param] }
        })
        payload.values = updatedValues
      } else {
        payload.values = this.fieldModel
      }
      payload.action = this.action

      this.fieldModel = {}
      // console.log('PAYLOAD', JSON.stringify(payload));
      this.$emit('accept', payload)
    },
    close() {
      this.fieldModel = {}
      this.isVisible = false
    },
    reset() {
      this.fieldModel = this.init()
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId']),
    ...mapGetters('admin', ['activeComponent']),
    isEdit() {
      return this.action === 'edit'
    }
  },
  watch: {
    action() {
      if (this.isEdit) { this.initialState = Object.assign({}, this.init(true)) }
    },
    show() {
      this.isVisible = this.show
      this.fieldModel = this.init()
    },
    isVisible() {
      this.$emit('stateChange', this.isVisible)
    },
    data() {
      console.log('DATA CHANGED')
      this.fieldModel = this.init()
    }
  }
}
</script>

<style></style>
